
export const getExpiryDate = (noOfDays: number): Date => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + noOfDays);
  return expiryDate;
};
